export default {
  namespaced: true,
  risk: {
    title: "Risk Management",
    template: {
      title: "Form Template | Form Templates",
      name: "Name",
      question: "Question | Questions",
      add_new_field: "Add a New Field",
      type_response: "Response Type",
      field_name: "Field Name",
      field_types: "Field Types",
      field_type_config: "Field Type Configuration",
      options: "Options",
      option_name: "Option Name",
      add_option: "Add an Option",
      added_options: "Added Options",
      add_section: "Add section",
      new_section: "New section",
      section_name: "Section name",
      no_section: "No section",
      add_field_here: "Add question here",
      drop_or_add_here: "Drop or add here",
      confirm_delete_section:
        "Delete the section? Its questions will be moved to 'No section'.",
      confirm_delete_field: "Delete this question?",
      visibility: "Visibility",
      condition: "Condition",
      previous_question: "Previous question...",
      match_any: "Match any",
      match_all: "Match all",
      select_one_or_more: "Select one or more options (Ctrl/Cmd + click).",
      select_option: "Select...",
      clear: "Clear",
      no_conditions: "No conditions: this field is always visible.",
      error_invalid_conditions: "The referenced question no longer exists in this section.",
      error_invalid_order: "The referenced question must be previous.",
      error_missing_value: "Select at least one option for the condition.",
      placeholder_value: "Placeholder Value",
      placeholder_hint: "E.g: @DATE, @TIME, @ID",
      placeholder_available: "Available",
      placeholder_separator_hint: "You can add multiple values separated by commas or dashes",
      add_placeholder: "Add Placeholder",
      added_placeholders: "Added Placeholders",
      placeholder_already_exists: "This placeholder already exists",

      // Placeholder values
      placeholder_date: "@DATE",
      placeholder_time: "@TIME",
      placeholder_datetime: "@DATETIME",
      placeholder_reference: "@REFERENCE",
      placeholder_id: "@ID",
    },
    evaluation: {
      title: "Evaluation | Evaluations",
    },
    form_validations: {
      name: "The name is required",
      type: "The type is required",
    },
    form: {
      title: "risk form",
    },
    required: "Required",
    risk_percentage: "Risk Percentage (%)",
    close: "Close",
    Apply: "Apply",
    comment: "Comment",
    file: "Files",
    select_form: "Select the risk assessment form",
    select_form_place_holder: "Select a form",
    selected_form: "Selected form",
    answer_form: "Answer form",
    new_evaluation: "New Evaluation",
    risk_evaluations_title: "Risk Evaluations",
    confirm_delete: "Are you sure you want to delete this evaluation?",
    download: "Download evaluation",
    evaluation_deleted: "Evaluation deleted",
    no_evaluations: "No evaluations found",
    filters: {
      units: "Units",
      users: "Users",
      status: "Status",
      date_range: "Date Range",
      start_date: "Start Date",
      end_date: "End Date",
      status_form: "Status Form",
    },
    operational_procedures: "Operational Procedures",
    reference_number: "Reference Number",
    title_notification: "Risk evaluation",
    status_notification: "Status",
    status_schedule: "Scheduled",
    status_in_progress: "In Progress",
    status_in_review: "In Review",
    status_assigned: "Assigned",
    status_in_review: "In Review",
    status_approved_cancelled: "Approved/Cancelled",
    status_rejected: "Rejected",
    status_approved: "Approved",
    status_canceled: "Canceled",
    status_reassigned: "Reassigned",
    remove_notification: "Remove",
    no_completed_evaluations: "No completed evaluations",
    last_completed_result: "Last completed result",
    add_comment: "Add a comment",
    review_comments_title: "Review comments",
    drop_or_add_here: "Drop or add here",
    user: "User",
  },
  confirm_cancel: "Are you sure you want to cancel this risk evaluation?",
  canceled: "Risk evaluation canceled",
};
